import { Component, Input, NgZone, OnChanges, OnInit, ViewChild } from '@angular/core';
import { GridComponent, GridDataResult } from '@progress/kendo-angular-grid';
import { take } from 'rxjs/operators';
import { State, process } from '@progress/kendo-data-query';
import { FileService } from '../../services/file.service';
import { UtilService } from '../../services/util.service';
import {
    SearchBlobFile
} from '../../models/models';

@Component({
    selector: 'documents-grid',
    templateUrl: './documents-grid.component.html',
    standalone: false
})
export class DocumentsGrid implements OnChanges, OnInit {
    @Input() recordID: number = 0;
    @Input() recordTypeName: string = "";
    @ViewChild(GridComponent, { static: false }) public documentsGrid!: GridComponent;

    public searchBlobFileList: SearchBlobFile[] = [];
    public docViewerFileName: string = "";
    public docViewerFileUri: string = "";

    public gridData: GridDataResult = { data: [], total: 0 };
    public gridState: State = { skip: 0, take: 15, sort: [{ dir: 'asc', field: 'recordTypeName' }, { dir: 'asc', field: 'fileName' }] };

    constructor(private fileService: FileService,
        private utilService: UtilService,
        private ngZone: NgZone) {
    }

    ngOnInit() {
    }

    ngOnChanges() {
        this.getSearchBlobFiles();
    }

    private getSearchBlobFiles() {
        this.utilService.isLoading = true;
        this.fileService.getSearchBlobFilesByRecordTypeNameRecordID(this.recordTypeName, this.recordID).subscribe(result => {
            this.searchBlobFileList = result.resultCollection;
            //console.log("getSearchBlobFiles", this.searchBlobFileList, this.documentTypeList);
            this.utilService.isLoading = false;
            this.setGrid();
        });
    }

    private setGrid() {
        this.gridData = process(this.searchBlobFileList, this.gridState);
        this.fitColumns();
        //console.log("setGrid", load, this.gridData);
    }

    private fitColumns() {
        this.ngZone.onStable.asObservable().pipe(take(1)).subscribe(() => {
            if (this.documentsGrid == null) return;
            this.documentsGrid.autoFitColumns();
        });
    }

    public viewFile(blobFile: SearchBlobFile) {
        if (blobFile.fileName) {
            this.docViewerFileName = blobFile.fileName;
            //this.docViewerFileUri = blobFile.blobUri;
            this.docViewerFileUri = this.fileService.download(blobFile.fileName);
        }
        else {
            this.docViewerFileName = "";
            this.docViewerFileUri = "";
        }
    }

    public downloadFile(blobFile: SearchBlobFile) {
        //this.fileService.download(blobFile.fileName).subscribe(result => {
        //    window.open(result, "_blank");
        //    //console.log("downloadFile", result);
        //    //window.open(blobFile.blobUri, "_blank");
        //});
        window.open(this.fileService.download(blobFile.fileName), "_blank");
    }
}
